import { useAtom } from "jotai";
import { BorderlessButton } from "@podtrac/common/components/BorderlessButton";
import { filterAtom, sortAtom, viewAtom } from "../dashboard/Dashboard";
import styles from "./Toolbar.module.scss";
import PaidFeatureButton from "../shared/PaidFeatureButton";
import ExportButton from "../shared/ExportButton";
import { useAccount } from "../store/account";
import { useRef } from "react";
import { FaTimes } from "react-icons/fa";
import * as classnames from "classnames";

export function Toolbar() {

    const { pending: isLoading, data: account } = useAccount();

    const inputRef = useRef();
    const [filter, setFilter] = useAtom(filterAtom);

    const [sort, setSort] = useAtom(sortAtom);
    const sortChange = event => setSort(event.target.value);

    const [view, setView] = useAtom(viewAtom);
    const viewChange = event => setView(event.target.value);

    return <>
        <div className={styles.toolbar}>
            <h2>Shows</h2>
            <form
                onSubmit={event => {
                    event.preventDefault();
                    setFilter(inputRef.current.value);
                }}
            >
                <input type="text" ref={inputRef} defaultValue={filter} className={styles.filter} placeholder="filter by title" />
            </form>
            <BorderlessButton className={classnames(styles.clear, { [styles.hidden]: !filter })} title="Clear filter" onClick={() => {
                inputRef.current.value = "";
                setFilter("");
            }}><FaTimes /></BorderlessButton>
            {"\u2003"}
            Sort by
            <label>
                <input type="radio" name="sort2" value="T" checked={sort == "T"} onChange={sortChange} />
                title
            </label>
            <label>
                <input type="radio" name="sort2" value="D" checked={sort == "D"} onChange={sortChange} />
                downloads
            </label>
            {"\u2003"}
            View as
            <label>
                <input type="radio" name="view" value="card" checked={view == "card"} onChange={viewChange} />
                cards
            </label>
            <label>
                <input type="radio" name="view" value="table" checked={view == "table"} onChange={viewChange} />
                table
            </label>
            {"\u2003"}
            {account && (account.isPaidPlan || account.offerUpgrade) ? (
                <PaidFeatureButton
                    hasFeature={account.isPaidPlan}
                    dialogContent="Export of this report to an Excel file is a premium feature available in the Grow Your Show Plan."
                >
                    {({ hasFeature, openModal }) => {
                        return (
                            <ExportButton
                                onClick={
                                    hasFeature
                                        ? () =>
                                            (window.location = `/__/${ account.accountID }/reports/keymetricsexport`)
                                        : openModal
                                }
                            />
                        );
                    }}
                </PaidFeatureButton>
            ) : null}
        </div>
        <div className={styles.shadow} />
        <div className={styles.cover} />
    </>;
}